import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { AlSection, AlSelfCareRow } from 'PatientCareCenter/Note/AL';
import styles from './Common.module.css';
import { codeValidForAdmit } from '_helpers';
import { CancelButton, StatusGood } from '_components';


class AlSelfCare extends React.Component {

    constructor(props) {
        super();
        this.state = {
            showWarning: false
        };
    }

    add() {
        if (this.props.trtValid || (!this.props.trtValid && this.props.selfcares.length > 0)) {
            this.props.addAlRow(this.props.noteId, 'MLSELFCARE', 'XLSC', 'XLSCNO', 'XLSCXLNO', this.props.xlno, 'NEW_XLSCNO');
            this.setState({ showWarning: false });
        } else if (!this.props.trtValid && this.props.selfcares.length === 0) {
            this.setState({ showWarning: true });
        }
    }

    componentDidUpdate() {
        if (this.props.selfcares.length === 0 && this.props.time !== null) {
            this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLTIMESELFCARE', 'XLTIMESELFCAREASSIST', 'XLTIMESELFCARETHERAPIST']);
        }
    }

    confirmPending() {
        this.props.addAlRow(this.props.noteId, 'MLSELFCARE', 'XLSC', 'XLSCNO', 'XLSCXLNO', this.props.xlno, 'NEW_XLSCNO');
        this.setState({ showWarning: false });
    }

    remove() {
        this.setState({ showWarning: false });
    }

    render() {
        return (
            <AlSection
                id='al_selfcare'
                name='Self-Care (97535)'
                timeField='XLTIMESELFCARE'
                timeRequired={this.props.containsPerformed && this.props.time === null ? true : false}
                timeVisible={this.props.selfcares.length > 0 ? true : false}
                trackAssist={this.props.trackAssist}
                onAdd={() => this.add()}
                className={this.props.className}
            >

                {this.state.showWarning &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.warning_msg}>This treatment code is not covered by the patient's payer and will <b>not</b> be reimbursed.  Do you wish to add it anyway?</span>
                        <span className={styles.yes_button} >
                            <StatusGood size='extra-small' title='Yes' onClick={() => this.confirmPending()} />
                        </span>
                        <span className={styles.no_button} >
                            <CancelButton size='extra-small' title='No' onClick={() => this.remove()} />
                        </span>
                    </div>
                }

                {this.props.selfcares.length > 0 &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.col1_header}>To Improve</span>
                        <span className={styles.col2_header}>Activity</span>
                        <span className={styles.col3_header}>Sets/Reps/Weight/Time</span>
                        <span className={styles.col4_header}>Performed</span>
                    </div>
                }

                {Object.keys(this.props.selfcares)
                    .map(key => {
                        const result = this.props.selfcares[key];
                        return (
                            <AlSelfCareRow key={result.XLSCNO} id={result.XLSCNO} />
                        )
                    })
                }
            </AlSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addAlRow: bindActionCreators(noteActions.addAlRow, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let trackAssist = state.entities.admissions[epno].contractTracksAssistant;
    let isLicensed = state.entities.authentication.user.islicensed;
    let containsPerformed = state.entities.notes.MLSELFCARE &&
        Object.keys(state.entities.notes.MLSELFCARE)
            .filter(key => {
                return (state.entities.notes.MLSELFCARE[key].XLSCXLNO === xlno && state.entities.notes.MLSELFCARE[key].XLSCPERFORMED)
            }).length > 0 ? true : false;


    return {
        noteId,
        xlno,
        time: state.entities.notes.MLEXLOG[xlno].XLTIMESELFCARE,
        trtValid: codeValidForAdmit(epno, '97535'),
        selfcares: Object.keys(state.entities.notes.MLSELFCARE)
            .filter(key => {
                return (state.entities.notes.MLSELFCARE[key].XLSCXLNO === xlno)
            })
            .sort((a, b) => state.entities.notes.MLSELFCARE[a].XLSCNO - state.entities.notes.MLSELFCARE[b].XLSCNO)
            .map(key => state.entities.notes.MLSELFCARE[key]),
        trackAssist,
        isLicensed,
        containsPerformed,
    };
}

const connectedAlSelfCare = connect(mapStateToProps, mapDispatchToProps)(AlSelfCare);
export { connectedAlSelfCare as AlSelfCare };

